import React, { useState } from 'react';
import { Play, X } from 'lucide-react';
import { IMAGES } from '../mock';

const PassiveGrowth = () => {
  const [open, setOpen] = useState(false);

  return (
    <section className="relative py-32 bg-[#0a2c4d] overflow-hidden">
      <div
        className="absolute inset-0 opacity-25"
        style={{ backgroundImage: `url(${IMAGES.passive})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0a2c4d]/95 via-[#0a2c4d]/85 to-[#0a2c4d]/70" />
      <div className="relative max-w-[1280px] mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="font-serif-display text-white text-4xl md:text-5xl font-bold leading-tight mb-6">
            A Passive Growth Opportunity for Investors Building Long-Term Assets
          </h2>
          <p className="text-white/80 text-[16px] leading-relaxed mb-8 max-w-xl">
            Discover strategic investment opportunities designed for sustainable, long-term wealth creation. Our platform
            connects visionary investors with high-potential ventures across industries.
          </p>
          <button onClick={() => setOpen(true)} className="pill-btn">Watch Story</button>
        </div>
        <div className="flex justify-center lg:justify-end">
          <button onClick={() => setOpen(true)} className="play-btn" aria-label="Play video">
            <Play size={30} fill="currentColor" className="ml-1" />
          </button>
        </div>
      </div>

      {open && (
        <div className="fixed inset-0 z-[60] bg-black/80 flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <button className="absolute top-6 right-6 text-white" onClick={() => setOpen(false)}><X size={30} /></button>
          <div className="w-full max-w-4xl aspect-video" onClick={(e) => e.stopPropagation()}>
            <iframe
              className="w-full h-full rounded-xl"
              src="https://www.youtube.com/embed/aIuW1wohClQ?autoplay=1"
              title="Story video"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default PassiveGrowth;
